module.exports = __webpack_public_path__ + "static/award-417494b197b06a48a7daa9fdd1da6111.jpg";